// extracted by mini-css-extract-plugin
export default {"balanceContainer":"balanceContainer-2mZVN","heading":"heading-3gcrk","breadcrumb":"breadcrumb-2Da7K","subText1":"subText1-3HjPJ"};